import { defineComponent as _defineComponent } from 'vue';
import { createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-04d4378c"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "free"
};

var _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"top\" data-v-04d4378c><span data-v-04d4378c>Riscern Free</span></div><div class=\"info\" data-v-04d4378c><div class=\"list\" data-v-04d4378c><div data-v-04d4378c><div class=\"item\" data-v-04d4378c><span class=\"high-text\" data-v-04d4378c></span>Free dataset (Registration Information)</div><div class=\"item\" data-v-04d4378c><span class=\"high-text\" data-v-04d4378c></span>Verify up to 10 companies per day</div><div class=\"item\" data-v-04d4378c><span class=\"high-text\" data-v-04d4378c></span>Verify up to 50 companies per month</div></div></div></div>", 2);

var _hoisted_4 = [_hoisted_2];
export default /*#__PURE__*/_defineComponent({
  props: {
    currentData: Object,
    initData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  setup: function setup(__props) {
    var props = __props;
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4);
    };
  }
});